import React, { Component } from 'react'
import './AboutMe.css'

export default class AboutMe extends Component {
  render() {
    return (
      <div id="about" className="about-me">
        <div className="about-me-logos">
          <img
            className="uva-me-logo"
            src="images/uva-logo.png"
            alt="University of Virginia"
          />
          <img
            className="me-logo"
            src="images/mark-circle.jpg"
            alt="Mark Moeller"
          />
          <img
            className="ga-me-logo"
            src="images/ga-logo.png"
            alt="General Assembly"
          />
        </div>
        <p className="summary-text">
          Adaptable Full Stack Web Developer with a strategic business mindset
          specializing in JavaScript and TypeScript. Currently working on
          projects in React and React Native.
        </p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/AboutMe.js